import ReactOnRails from 'react-on-rails/client';
import ContractorProfile from '../../components/ror_components/ContractorProfile.jsx';

ReactOnRails.register({ContractorProfile});